exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".verify-token[data-v-d9acb984]{position:relative}.verify-token p[data-v-d9acb984]{position:absolute;left:0;right:0;bottom:50px}p.text-center.loaded[data-v-d9acb984]{bottom:0;position:relative;margin-top:80px}", ""]);

// exports
